import React from 'react';
import { Mask } from 'utils/mask';

import { Input } from 'reactComponents/Input/Input';

export class MaskedInput extends React.PureComponent {
    componentDidMount() {
        if (this._inputRef) {
            Mask.applyMask({
                element: this._inputRef,
                mask: this.props.mask,
                maskOptions: this.props.maskOptions,
                maskPattern: this.props.maskPattern,
            });

            // need to subscribe on change manually, because semantic input bugs when masked and don't call onChange in some cases
            this._inputRef.addEventListener('input', this._onInputRefChange);
        }
    }

    componentWillUnmount() {
        if (this._inputRef) {
            Mask.unMask(this._inputRef);
            this._inputRef.removeEventListener('input', this._onInputRefChange);
        }
    }

    _onInputRefChange = (event) => {
        this.props.onChange(event, {
            ...this.props,
            value: this.props.cleanMaskedValue
                ? Mask.getCleanValue(this._inputRef)
                : event.target.value,
        });
    };

    render() {
        const {
            onChange,
            maskPattern,
            maskOptions,
            cleanMaskedValue,
            mask,
            value,
            ...restProps
        } = this.props;
        return (
            <Input
                {...restProps}
                inputRef={(node) => {
                    this._inputRef = node;
                }}
                value={Mask.makeMaskedValue({
                    element: this._inputRef,
                    value: value || '',
                })}
            />
        );
    }
}
